import { createAction, props } from '@ngrx/store';
import { ActionUpdate, Comment, Task } from '../../interface/task.interface';

import { TaskAssignee } from '../../interface/task_assignee.interface';

enum TasksActions {
    TASKS_GET_TASKS = '[TASKS] Get Tasks',
    TASKS_SET_TASKS = '[TASKS] Set Tasks',
    TASKS_SET_TASK_DEFINITION_ID = '[TASKS] Set Plan ID',
    TASKS_SET_SELECTED_TASK_TYPE = '[TASKS] Set Selected Task Type',
    TASKS_SET_SELECTED_TASK_ID = '[TASKS] Set Selected Task ID',
    TASKS_CREATE_TASK = '[TASKS] Create Task',
    TASKS_SET_TASK = '[TASKS] Set Task',
    TASKS_SET_TASK_INSTANCE = '[TASKS] Set Task Instance',
    TASKS_UPDATE_TASK = '[TASKS] Update Task',
    TASKS_UPDATE_TASK_FROM_LIST = '[TASKS] Update Task From List',
    TASKS_DELETE_TASK = '[TASKS] Delete Task',
    TASKS_GET_TASK = '[TASKS] Get Task',
    TASKS_GET_TASK_ASSIGNEES = '[TASKS] Get Task Assignee',
    TASKS_SET_TASK_ASSIGNEES = '[TASKS] Set Task Assignee',
    TASKS_CREATE_TASK_ASSIGNEES = '[TASKS] Create Task Assignee',
    TASKS_SUBMIT_TASK_ASSIGNEES = '[TASKS] Submit Task Assignee',
    TASKS_DELETE_TASK_ASSIGNEE = '[TASKS] Delete Task Assignee',
    TASKS_GET_CHILD_TASKS = '[TASKS] Get Child Tasks',
    TASKS_SET_CHILD_TASKS = '[TASKS] Set Child Tasks',
    TASKS_GET_FUTURE_INSTANCES = '[TASKS] Get Future Task Instances',
    TASKS_SET_FUTURE_INSTANCES = '[TASKS] Set Future Task Instances',
    TASKS_CLEAR_FUTURE_INSTANCES = '[TASKS] Clear Future Task Instances',
    TASKS_GET_TASK_INSTANCES = '[TASKS] Get Task Instances',
    TASKS_SET_TASK_INSTANCES = '[TASKS] Set Task Instances',
    TASKS_SET_CHILD_TASK_INSTANCES = '[TASKS] Set Child Task Instances',
    TASKS_GET_COMMENTS = '[TASKS] Get Comments',
    TASKS_SET_COMMENTS = '[TASKS] Set Comments',
    TASKS_SET_COMMENT = '[TASKS] Set Comment',
    TASKS_CREATE_COMMENT = '[TASKS] Create Comment',
    TASKS_UPDATE_COMMENT = '[TASKS] Update Comment',
    TASKS_GET_ACTION_UPDATES = '[TASKS] Get Action Updates',
    TASKS_SET_ACTION_UPDATES = '[TASKS] Set Action Updates',
    TASKS_SET_PARENT_TASK_ID = '[TASKS] Set Parent Task ID',
    TASKS_CREATE_OR_EDIT_TASK = '[TASKS] Create Or Edit Task',
    SET_SELECTED_PARENT_INSTANCE_ID = '[TASKS] Set Selected Parent Instance ID',
    SET_INSTANCE_ID__FOR_COMMENTS = '[TASKS] Set Instance Id For Comments',
    GET_CHILD_TASK_INSTANCES_WITH_DETAILS = '[TASKS] Get Child Task Instances With Details',
    SEARCH_CHILD_TASK_INSTANCES = '[TASKS] Search Child Task Instances',
    SET_FILTERED_CHILD_TASK_INSTANCES = '[TASKS] Set Filtered Child Task Instances',
    CLEAR_FILTERED_CHILD_TASK_INSTANCES = '[TASKS] Clear Filtered Child Task Instances',
    GET_CHILD_TASK_DEFINITIONS_WITH_DETAILS = '[TASKS] Get Child Task Definitions With Details',
    TASKS_GET_STATUS_GROUPS = '[TASKS] Get Status Groups',
    TASKS_SET_STATUS_GROUPS = '[TASKS] Set Status Groups',
    TASKS_GET_STATUS_GROUPS_SUCCESS = '[TASKS] Get Status Groups Success',
    TASKS_CREATE_STATUS_GROUP = '[TASKS] Create Status Group',
    TASKS_CREATE_STATUS_GROUP_SUCCESS = '[TASKS] Create Status Group Success',
    TASKS_DELETE_OR_DISABLE_TASK = '[TASKS] Delete Or Disable Task',
    TASKS_GET_ROOT_TASK_INSTANCES = '[TASKS] Get Root Task Instances',
    TASKS_CREATE_LINKS = '[TASKS] Create Links',
    TASKS_CREATE_LINK = '[TASKS] Create Link',
    TASKS_CREATE_LINK_SUCCESS = '[TASKS] Create Link Success',
    TASKS_GET_LINK = '[TASKS] Get Link',
    TASKS_DELETE_LINK = '[TASKS] Delete Link',
    TASKS_GET_LINK_SUCCESS = '[TASKS] Get Link Success',
    TASKS_GET_LINK_FAILURE = '[TASKS] Get Link Failure',
    TASKS_DELETE_LINK_SUCCESS = '[TASKS] Delete Link Success',
    TASKS_CREATE_NOTIFIERS = '[TASKS] Create Notifiers',
    TASKS_CREATE_NOTIFIER = '[TASKS] Create Notifier',
    TASKS_CREATE_NOTIFIER_SUCCESS = '[TASKS] Create Notifier Success',
    TASKS_UPDATE_NOTIFIER = '[TASKS] Update Notifier',
    TASKS_UPDATE_NOTIFIER_SUCCESS = '[TASKS] Update Notifier Success',
    TASKS_GET_NOTIFIER = '[TASKS] Get Notifier',
    TASKS_DELETE_NOTIFIER = '[TASKS] Delete Notifier',
    TASKS_GET_NOTIFIER_SUCCESS = '[TASKS] Get Notifier Success',
    TASKS_GET_NOTIFIER_FAILURE = '[TASKS] Get Notifier Failure',
    TASKS_DELETE_NOTIFIER_SUCCESS = '[TASKS] Delete Notifier Success',
    TASKS_DELETE_COMMENT = '[TASKS] Delete Comment',
    TASKS_GET_ACTIONS = '[TASKS] Get Task Actions',
    TASKS_SET_ACTIONS = '[TASKS] Set Task Actions',
    TASKS_SAVE_ACTION = '[TASKS] Save Task Action',
    TASKS_SAVE_ACTION_SUCCESS = '[TASKS] Save Task Action Success',
    TASKS_SAVE_ACTION_FAILURE = '[TASKS] Save Task Action Failure',
    TASKS_UPDATE_ACTION = '[TASKS] Update Task Action',
    TASKS_UPDATE_ACTION_SUCCESS = '[TASKS] Update Task Action Success',
    TASKS_UPDATE_ACTION_FAILURE = '[TASKS] Update Task Action Failure',
    TASKS_DELETE_ACTION = '[TASKS] Delete Task Action',
    TASKS_DELETE_ACTION_SUCCESS = '[TASKS] Delete Task Action Success',
    TASKS_DELETE_ACTION_FAILURE = '[TASKS] Delete Task Action Failure',
    SHOW_TASK_NOTIFICATIONS = '[TASKS] Show Task Notifications',
    CREATE_ONE_SHOT_TASK_FOR_INSTANCE = '[TASKS] Create One Shot Task For Instance',
}

export const GetTasks = createAction(TasksActions.TASKS_GET_TASKS);

export const SetTasks = createAction(
    TasksActions.TASKS_SET_TASKS,
    props<{
        tasks: Task[];
    }>()
);

export const GetChildTasks = createAction(
    TasksActions.TASKS_GET_CHILD_TASKS,
    props<{
        taskId: string;
        taskType?: 'TASK_DEFINITION' | 'TASK_INSTANCE';
    }>()
);

export const SetChildTasks = createAction(
    TasksActions.TASKS_SET_CHILD_TASKS,
    props<{
        tasks: Task[];
        parentTaskId: string;
    }>()
);

export const GetTaskInstances = createAction(TasksActions.TASKS_GET_TASK_INSTANCES);

export const SetTaskInstances = createAction(
    TasksActions.TASKS_SET_TASK_INSTANCES,
    props<{
        taskInstances: any[];
    }>()
);

export const SetChildTaskInstances = createAction(
    TasksActions.TASKS_SET_CHILD_TASK_INSTANCES,
    props<{ tasks: Task[]; parentTaskId: string }>()
);

export const SetTaskDefinitionId = createAction(
    TasksActions.TASKS_SET_TASK_DEFINITION_ID,
    props<{
        taskId: string;
    }>()
);

export const SetSelectedTaskType = createAction(
    TasksActions.TASKS_SET_SELECTED_TASK_TYPE,
    props<{
        taskType: 'TASK_DEFINITION' | 'TASK_INSTANCE';
    }>()
);

export const SetSelectedTaskId = createAction(
    TasksActions.TASKS_SET_SELECTED_TASK_ID,
    props<{
        taskId: string;
    }>()
);

export const GetTask = createAction(
    TasksActions.TASKS_GET_TASK,
    props<{
        taskId: string;
        taskType: 'TASK_DEFINITION' | 'TASK_INSTANCE';
    }>()
);

export const CreateTask = createAction(
    TasksActions.TASKS_CREATE_TASK,
    props<{
        task: Task;
        assignees: TaskAssignee[];
        update: boolean;
        taskChanged: boolean;
        assigneesChanged: boolean;
        fromTable?: boolean;
        isRootPlan?: boolean;
    }>()
);

export const UpdateTask = createAction(
    TasksActions.TASKS_UPDATE_TASK,
    props<{
        task: Task;
        assignees: TaskAssignee[];
    }>()
);

export const UpdateTaskFromList = createAction(
    TasksActions.TASKS_UPDATE_TASK,
    props<{
        taskId: string;
        data: { property: string; value: any };
        taskType: 'TASK_DEFINITION' | 'TASK_INSTANCE';
        taskDefinitionId: string;
    }>()
);

export const DeleteTask = createAction(
    TasksActions.TASKS_DELETE_TASK,
    props<{
        task: Task;
    }>()
);

export const SetTask = createAction(
    TasksActions.TASKS_SET_TASK,
    props<{
        task: Task;
        actionType: 'CREATE' | 'EDIT' | 'DELETE';
        redirect?: boolean;
    }>()
);

export const SetTaskInstance = createAction(
    TasksActions.TASKS_SET_TASK_INSTANCE,
    props<{
        task: Task;
        actionType: 'CREATE' | 'EDIT' | 'DELETE';
        redirect?: boolean;
    }>()
);

export const GetTaskAssignees = createAction(
    TasksActions.TASKS_GET_TASK_ASSIGNEES,
    props<{
        taskId: string;
        loading?: boolean;
    }>()
);

export const SetTaskAssignee = createAction(
    TasksActions.TASKS_SET_TASK_ASSIGNEES,
    props<{
        taskId: string;
        taskType: 'TASK_DEFINITION' | 'TASK_INSTANCE';
        assignees: TaskAssignee[];
    }>()
);

export const UpdateTaskAssignees = createAction(
    TasksActions.TASKS_CREATE_TASK_ASSIGNEES,
    props<{
        taskId: string;
        assignees: TaskAssignee[];
        message?: string;
        taskType: 'TASK_DEFINITION' | 'TASK_INSTANCE';
        fromTable?: boolean;
    }>()
);

export const SubmitTaskAssignees = createAction(
    TasksActions.TASKS_SUBMIT_TASK_ASSIGNEES,
    props<{
        taskId: string;
        assignees: TaskAssignee[];
        message?: string;
        taskType: 'TASK_DEFINITION' | 'TASK_INSTANCE';
    }>()
);

export const DeleteTaskAssignee = createAction(
    TasksActions.TASKS_DELETE_TASK_ASSIGNEE,
    props<{
        taskId: string;
        assignees: string[];
        taskType: 'TASK_DEFINITION' | 'TASK_INSTANCE';
        message: string;
        getAssignees: boolean;
    }>()
);

export const GetFutureTaskInstances = createAction(TasksActions.TASKS_GET_FUTURE_INSTANCES, props<{ start: string; end: string }>());

export const SetFutureTaskInstances = createAction(
    TasksActions.TASKS_SET_FUTURE_INSTANCES,
    props<{ futureSchedules: { definition: Task; schedule: string[] }[] }>()
);

export const ClearFutureTaskInstances = createAction(TasksActions.TASKS_CLEAR_FUTURE_INSTANCES);

export const GetComments = createAction(
    TasksActions.TASKS_GET_COMMENTS,
    props<{
        taskId: string;
        update?: boolean;
    }>()
);

export const SetComments = createAction(
    TasksActions.TASKS_SET_COMMENTS,
    props<{
        comments: Comment[];
        taskId: string;
    }>()
);

export const CreateComment = createAction(
    TasksActions.TASKS_CREATE_COMMENT,
    props<{
        taskId: string;
        formData: FormData;
    }>()
);

export const UpdateComment = createAction(
    TasksActions.TASKS_UPDATE_COMMENT,
    props<{
        taskId: string;
        commentId: string;
        formData: FormData;
    }>()
);

export const SetComment = createAction(
    TasksActions.TASKS_SET_COMMENT,
    props<{
        comment: Comment;
        taskId: string;
    }>()
);

export const GetActionUpdates = createAction(
    TasksActions.TASKS_GET_ACTION_UPDATES,
    props<{
        taskId: string;
        update?: boolean;
    }>()
);

export const SetActionUpdates = createAction(
    TasksActions.TASKS_SET_ACTION_UPDATES,
    props<{
        actionUpdates: ActionUpdate[];
        taskId: string;
    }>()
);

export const CreateOrEditTask = createAction(
    TasksActions.TASKS_CREATE_OR_EDIT_TASK,
    props<{
        task: Task;
    }>()
);

export const ShowTaskNotifications = createAction(
    TasksActions.SHOW_TASK_NOTIFICATIONS,
    props<{
        task: Task;
    }>()
);

export const CreateOneShotTaskForInstance = createAction(
    TasksActions.CREATE_ONE_SHOT_TASK_FOR_INSTANCE,
    props<{
        parentInstanceId: string;
    }>()
);

export const SetSelectedParentInstanceId = createAction(
    TasksActions.SET_SELECTED_PARENT_INSTANCE_ID,
    props<{
        instanceId: string;
    }>()
);

export const GetChildTaskInstancesWithDetails = createAction(
    TasksActions.GET_CHILD_TASK_INSTANCES_WITH_DETAILS,
    props<{
        taskId: string;
    }>()
);

export const SearchChildTaskInstances = createAction(
    TasksActions.SEARCH_CHILD_TASK_INSTANCES,
    props<{
        rootInstanceId: string;
        filter: any;
    }>()
);

export const SetFilteredChildTaskInstances = createAction(
    TasksActions.SET_FILTERED_CHILD_TASK_INSTANCES,
    props<{ taskIds: string[]; rootInstanceId: string }>()
);

export const ClearFilteredChildTaskInstances = createAction(
    TasksActions.CLEAR_FILTERED_CHILD_TASK_INSTANCES,
    props<{ rootInstanceId: string }>()
);

export const GetChildTaskDefinitionsWithDetails = createAction(
    TasksActions.GET_CHILD_TASK_DEFINITIONS_WITH_DETAILS,
    props<{
        taskId: string;
    }>()
);

export const GetStatusGroups = createAction(TasksActions.TASKS_GET_STATUS_GROUPS);

export const SetStatusGroups = createAction(
    TasksActions.TASKS_SET_STATUS_GROUPS,
    props<{
        statusGroups: any;
    }>()
);

export const CreateStatusGroup = createAction(
    TasksActions.TASKS_CREATE_STATUS_GROUP,
    props<{
        id?: string;
        name: string;
        description: string;
        is_default: boolean;
        statuses: any[];
    }>()
);

export const CreateStatusGroupSuccess = createAction(
    TasksActions.TASKS_CREATE_STATUS_GROUP_SUCCESS,
    props<{
        statusGroup: any;
    }>()
);

export const DeleteOrDisableTask = createAction(
    TasksActions.TASKS_DELETE_OR_DISABLE_TASK,
    props<{
        task: Task;
        enabled: boolean;
        childTask?: boolean;
    }>()
);

export const GetRootTaskInstances = createAction(
    TasksActions.TASKS_GET_ROOT_TASK_INSTANCES,
    props<{
        taskDefinitionId: string;
    }>()
);

export const CreateTaskLinks = createAction(
    TasksActions.TASKS_CREATE_LINKS,
    props<{
        taskId: string;
        links: {
            app_name: string;
            event_type: string;
            expression: string;
            task_definition_id: string;
            id?: string;
            custom_message?: string;
            service_user_id: string;
            organization?: string;
        }[];
    }>()
);

export const CreateLink = createAction(
    TasksActions.TASKS_CREATE_LINK,
    props<{
        taskId: string;
        linkData: {
            app_name: string;
            event_type: string;
            expression: string;
            task_definition_id: string;
            id?: string;
            custom_message?: string;
            service_user_id: string;
            organization?: string;
        };
        message?: string;
    }>()
);

export const CreateLinkSuccess = createAction(
    TasksActions.TASKS_CREATE_LINK_SUCCESS,
    props<{
        link: any;
    }>()
);

export const GetLinks = createAction(
    TasksActions.TASKS_GET_LINK,
    props<{
        taskId: string;
    }>()
);

export const GetLinksSuccess = createAction(TasksActions.TASKS_GET_LINK_SUCCESS, props<{ links: any[] }>());

export const DeleteLink = createAction(
    TasksActions.TASKS_DELETE_LINK,
    props<{
        taskId: string;
        linkId: string;
    }>()
);

export const DeleteLinkSuccess = createAction(TasksActions.TASKS_DELETE_LINK_SUCCESS, props<{ linkId: string }>());

export const GetLinksFailure = createAction(TasksActions.TASKS_GET_LINK_FAILURE, props<{ error: string }>());

export const CreateTaskNotifiers = createAction(
    TasksActions.TASKS_CREATE_NOTIFIERS,
    props<{
        taskId: string;
        notifiers: {
            event_type: string;
            schedule: string;
            roles: { id: string; name: string }[];
            users: { id: string; name: string }[];
            definition_id: string;
        }[];
    }>()
);

export const CreateNotifier = createAction(
    TasksActions.TASKS_CREATE_NOTIFIER,
    props<{
        taskId: string;
        notifierData: {
            event_type: string;
            schedule: string;
            roles: { id: string; name: string }[];
            users: { id: string; name: string }[];
            definition_id: string;
        };
        message?: string;
    }>()
);

export const CreateNotifierSuccess = createAction(
    TasksActions.TASKS_CREATE_NOTIFIER_SUCCESS,
    props<{
        notifier: any;
    }>()
);

export const UpdateNotifier = createAction(
    TasksActions.TASKS_UPDATE_NOTIFIER,
    props<{
        taskId: string;
        notifierData: {
            event_type: string;
            schedule: string;
            roles: { id: string; name: string }[];
            users: { id: string; name: string }[];
            definition_id: string;
        };
        message?: string;
    }>()
);

export const UpdateNotifierSuccess = createAction(
    TasksActions.TASKS_UPDATE_NOTIFIER_SUCCESS,
    props<{
        notifier: any;
    }>()
);

export const GetNotifiers = createAction(
    TasksActions.TASKS_GET_NOTIFIER,
    props<{
        taskId: string;
    }>()
);

export const GetNotifiersSuccess = createAction(TasksActions.TASKS_GET_NOTIFIER_SUCCESS, props<{ notifiers: any[] }>());

export const DeleteNotifier = createAction(
    TasksActions.TASKS_DELETE_NOTIFIER,
    props<{
        taskId: string;
        eventType: string;
    }>()
);

export const DeleteNotifierSuccess = createAction(TasksActions.TASKS_DELETE_NOTIFIER_SUCCESS, props<{ eventType: string }>());

export const GetNotifiersFailure = createAction(TasksActions.TASKS_GET_NOTIFIER_FAILURE, props<{ error: string }>());

export const DeleteComment = createAction(
    TasksActions.TASKS_DELETE_COMMENT,
    props<{
        taskId: string;
        commentId: string;
    }>()
);

export const GetTaskActions = createAction(TasksActions.TASKS_GET_ACTIONS);

export const SetTaskActions = createAction(
    TasksActions.TASKS_SET_ACTIONS,
    props<{
        actions: {
            id: string;
            definition_id: string;
            action_type: string;
            description: string;
            target_params: string;
            service_user_id: string;
            is_deleted: string;
        }[];
        taskDefinitionId: string;
    }>()
);

export const SaveTaskAction = createAction(
    TasksActions.TASKS_SAVE_ACTION,
    props<{
        taskDefinitionId: string;
        actionData: any;
    }>()
);

export const SaveTaskActionSuccess = createAction(
    TasksActions.TASKS_SAVE_ACTION_SUCCESS,
    props<{
        action: any;
        taskDefinitionId: string;
    }>()
);

export const SaveTaskActionFailure = createAction(TasksActions.TASKS_SAVE_ACTION_FAILURE, props<{ error: string }>());

export const UpdateTaskAction = createAction(
    TasksActions.TASKS_UPDATE_ACTION,
    props<{
        taskDefinitionId: string;
        actionId: string;
        actionData: any;
    }>()
);

export const UpdateTaskActionSuccess = createAction(
    TasksActions.TASKS_UPDATE_ACTION_SUCCESS,
    props<{
        action: any;
        taskDefinitionId: string;
    }>()
);

export const UpdateTaskActionFailure = createAction(TasksActions.TASKS_UPDATE_ACTION_FAILURE, props<{ error: string }>());

export const DeleteTaskAction = createAction(
    TasksActions.TASKS_DELETE_ACTION,
    props<{
        taskDefinitionId: string;
        actionId: string;
    }>()
);

export const DeleteTaskActionSuccess = createAction(
    TasksActions.TASKS_DELETE_ACTION_SUCCESS,
    props<{
        actionId: string;
        taskDefinitionId: string;
    }>()
);

export const DeleteTaskActionFailure = createAction(TasksActions.TASKS_DELETE_ACTION_FAILURE, props<{ error: string }>());
